"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Tooltip.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
var _TooltipMethods = require("./TooltipMethods");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Tooltip = _ref => {
  let {
    tooltipLabel,
    direction,
    children
  } = _ref;
  const icon = (0, _TooltipMethods.checkForIcon)(tooltipLabel);
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-tooltip",
    "data-direction": direction
  }, tooltipLabel && !icon && /*#__PURE__*/_react.default.createElement("a", null, tooltipLabel), tooltipLabel && icon && /*#__PURE__*/_react.default.createElement("a", null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: tooltipLabel[0] && tooltipLabel[0]?.icon ? tooltipLabel[0]?.icon : null,
    size: tooltipLabel[1] && tooltipLabel[1]?.size ? tooltipLabel[1]?.size : "16px"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-tooltip__content"
  }, children && children));
};
var _default = Tooltip;
exports.default = _default;
Tooltip.propTypes = {
  direction: _propTypes.default.string.isRequired,
  children: _propTypes.default.node
};